const PhotoCredit = `
  id
  photoCredit
`;

export default PhotoCredit;
